<template>
  <dd-validation-rules-wrapper :name="name" :rules="rules">
    <template #default="validationWrapperProps">
      <validation-provider ref="provider" :name="name" :rules="validationWrapperProps.rules" v-slot="validationProps">
        <dd-input-wrapper
            :rules="validationWrapperProps.rules"
            :title="title"
            :errors="validationProps.errors"
            :name="name"
            :value="value"
            :provider-ref="$refs.provider"
            v-slot="{validateInput}"
        >
          <a-range-picker
              :data-dusk="dataDusk"
              @change="(newValue) => {validateInput(newValue); $emit('input', newValue)}"
              @blur="() => validateInput(value)"
              @openChange="panelOpen"
              :value="value"
              :defaultValue="defaultValue"
              v-bind="$attrs"
              :format="format"
              :valueFormat="valueFormat"
          >
            <a-icon slot="suffixIcon" type="calendar"/>
          </a-range-picker>
        </dd-input-wrapper>
  </validation-provider>
    </template>
  </dd-validation-rules-wrapper>
</template>

<script>
import DateFormatsEnum from '../enums/DateFormatsEnum';
import DateComponentFormattingMixin from "~/new_design_components/mixins/DateComponentFormattingMixin";

export default {
  name: "DateRangePicker.vue",
  emits: ['input'],
  mixins: [DateComponentFormattingMixin],
  props: {
    dataDusk: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: false
    },
    value: {
      type: [Array, Object],
      required: false
    },
    rules: {
      type: [String, Array, Object],
      required: false,
    },
    name: {
      type: String,
      required: false
    },
    defaultValue: {
      type: [String, Object],
      required: false
    },
    format: {
      required: false,
      default: DateFormatsEnum.DISPLAY_DATE,
      type: String,
    },
    valueFormat: {
      required: false,
      // Because this is default format used in database.
      default: DateFormatsEnum.DB_ENTRY,
      type: String,
    },
  },
  methods: {
    onChange(momentObjects) {
      this.$emit('input', momentObjects);
    },
    panelOpen(opened) {
      if (opened) {
        setTimeout(() => {
          const inputs = document.querySelectorAll('.ant-calendar-input');
          inputs[0].addEventListener('input', this.autoDateFormatting);
          inputs[1].addEventListener('input', this.autoDateFormatting);
          inputs[0].focus();
          if (this.value[0]) inputs[0].setSelectionRange(0, this.value[0].length);
        }, 100);
      } else {
        const inputs = document.querySelectorAll('.ant-calendar-input');
        inputs[0].removeEventListener('input', this.autoDateFormatting);
        inputs[1].removeEventListener('input', this.autoDateFormatting);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
